import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';

import styles from './ConnectionMonitor.module.css';

const ConnectionMonitor = props => {
  const [connState, setConnState] = useState( null );
  console.log( props );

  useEffect( () => {
    axios({
      method: 'get',
      baseURL: '/',
      url: '/api/v1/check_connections'
    })
    .catch( (error) => {console.log( error ); setConnState( {error: error })} )
    .then( (res) => {console.log( res ); setConnState( {...res.data })} )
  }, [] );

  let page;
  if ( connState ) {
    console.log( connState.epix );
    if ( connState.error ) {
      page = `An error occurred: ${connState.error}`
    } else {
      page = <div>
      <p>RxDB: <span className={connState.rxdb ? styles.green : styles.red}>&#x2B24;</span></p>
      <p>Pseudonymizer: <span className={connState.pseudonymizer ? styles.green : styles.red}>&#x2B24;</span></p>
    </div>
    }
  }

  return <div className={styles.monitor}>
    <h1>Connection Monitor</h1>

    {page}
  </div>

}

export default ConnectionMonitor;